import React from 'react';

import Badge, { BadgeInterface } from "../Badge";
import OptionalLink from "../OptionalLink";
import { OptionsButton } from "../Buttons";
import StatsIcons from "../StatsIcons";
import './style.scss';

interface propsInterface {
  children?: React.ReactNode;
  className?: string;
}

interface cardInlineInterface {
  title?: string;
  link?: string;
  stats?: React.ReactNode[];
  options?: React.ReactNode[];
  badge?: BadgeInterface['badge'];
  ribbon?: BadgeInterface['ribbon'];
}

const Card = ({ children, className }: propsInterface) => {
  return (
    <div className={`v-card ${className || ''}`}>
      {children}
    </div>
  );
}

Card.Inline = function ({ title, link, stats, options, badge, ribbon }: cardInlineInterface) {
  return (
    <div className='v-card-inline'>
      <Badge badge={badge} ribbon={ribbon}>
        <div className='o-body'>
          {title &&
            <OptionalLink link={link}>
              <h3 className='o-title'>{title}</h3>
            </OptionalLink>
          }
        </div>

        <div className='o-footer'>
          {stats && <StatsIcons icons={stats} />}

          {options && options.length && <OptionsButton key='settings' options={options} /> }
        </div>
      </Badge>
    </div>
  )
}

export default Card;
